import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useState } from "react";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "@/integrations/firebase/firestore";

export interface ISummaryMetadata {
  jobId: string;
  manuscriptTitle?: string | null;
  manuscriptAuthor?: string | null;
}

export const useSummaries = (limitCount: number) => {
  const { authUser } = useAuth();
  const [metadatas, setMetadatas] = useState<ISummaryMetadata[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    if (!authUser) {
      setIsLoading(false);
      return;
    }

    const q = query(
      collection(db, "summaries"),
      where("user_id", "==", authUser.uid),
      orderBy("created_at", "desc"),
      limit(limitCount),
    );

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const metadataCollection: ISummaryMetadata[] = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          metadataCollection.push({
            jobId: data.job_id,
            manuscriptTitle: data.manuscript?.metadata?.title,
            manuscriptAuthor: data.manuscript?.metadata?.author,
          });
        });
        setMetadatas(metadataCollection);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [authUser, limitCount]);

  return { metadatas, isLoading, error };
};
